import { Turno } from 'src/app/shared/models/escola/Turno';

const NOMES_TURNO: Record<number, string> = {
  0: 'Sem Turno',
  1: 'Manhã',
  2: 'Intermediário',
  3: 'Tarde',
  4: 'Vespertino',
  5: 'Noite',
  6: 'Integral',
};

export function normalizarTurnosApi(dados: any[] | null | undefined): Turno[] {
  if (!dados?.length) {
    return [];
  }

  return dados.map((item) => {
    const codigoTurno = item.codigoTurno ?? item.CodigoTurno;
    const nomeTurno =
      item.nomeTurno ??
      item.NomeTurno ??
      NOMES_TURNO[codigoTurno] ??
      '';

    return { codigoTurno, nomeTurno };
  });
}
